// Source/Anchor-Links/mod.ts
document.addEventListener("click", onAnchorClick, {
  capture: true
});
function onAnchorClick(event) {
  let { target } = event;
  if (!target)
    return;
  if (!(target instanceof Element))
    return;
  if (!(target instanceof HTMLAnchorElement)) {
    target = target.closest(`a`);
    if (!target)
      return;
  }
  const { href } = target;
  const there = new URL(href);
  const here = new URL(location.href);
  if (here.host !== there.host)
    return;
  if (here.pathname !== there.pathname)
    return;
  if (there.hash === "")
    return;
  const destination = document.querySelector(there.hash);
  if (!destination)
    return;
  destination.scrollIntoView({
    behavior: "smooth",
    block: "start"
  });
  event.preventDefault();
}

// Source/Vendor-Overview/Component.ts
class VendorOverview extends HTMLElement {
  controller = new AbortController;
  connectedCallback() {
    const root = this.shadowRoot;
    root?.addEventListener("click", onAnchorClick, {
      capture: true,
      signal: this.controller.signal
    });
  }
  disconnectedCallback() {
    this.controller.abort();
  }
}

// Source/Vendor-Overview/mod.ts
customElements.define("vendor-overview", VendorOverview);
